// Copyright © 2021 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default Object.freeze({
  C_ACTIVE_BLUE: '#3D73FF',
  C_ACTIVE_BLUE_HOVER: '#1E5DFF',
  C_ACTIVE_BLUE_ACTIVE: '#0047FF',
  C_ICON_FILL: '#686868',
  C_SUBTLE_FILL: '#AAAAAA',
  C_BACKDROP: '#F3F3F3',
  C_BACKDROP_LIGHTER: '#FAFAFA',
  C_TEXT_BACKDROP: '#ECECEC',
  TC_ACTIVE: '#3D73FF',
  TC_ACTIVE_HOVER: '#3D73FF',
  TC_ERROR: '#EA0000',
})
